import errorManager from '@/rollbar.js';

var FormChange, findByDom, firstChangedForm, init, isChanged, observedForms;
observedForms = [];
FormChange = function (el) {
  this.dom = el;
  this.el = $(el);
  this.el.attr('form-changes-active', '');
  this.alertMessage = this.el.data('form-changes-message') || window.form_dirty;
  this.justSaved = false;
  this.resetChanged();
  this.bind();
};
const initLestener = () => {
  $('form')
    .not('[form-changes-active]')
    .has('.js-form-dirtiness-check')
    .each(function () {
      return observedForms.push(new FormChange(this));
    });
  window.onbeforeunload = function (ev) {
    if (window.FormChanges.isChanged() && !window.externalSubmit) {
      setTimeout(() => {
        eventBus.$emit('closeAdvLoader');
      }, 1000);
      return window.FormChanges.firstChangedForm().alertMessage;
    }
  };
};

const findByDomLestener = (dom) => {
  var i, len;
  i = 0;
  len = observedForms.length;
  while (i < len) {
    if (observedForms[i].dom === dom) {
      return observedForms[i];
    }
    i++;
  }
  return null;
};

const isChangedLestener = () => {
  var i, len;
  i = 0;
  len = observedForms.length;
  while (i < len) {
    if (observedForms[i].isChanged()) {
      return true;
    }
    i++;
  }
  return false;
};

const firstChangedFormLestener = () => {
  var i, len;
  i = 0;
  len = observedForms.length;
  while (i < len) {
    if (observedForms[i].isChanged()) {
      return observedForms[i];
    }
    i++;
  }
  return null;
};

FormChange.prototype = {
  constructor: FormChange,
  bind: function () {
    var me;
    me = this;
    eventBus.$on('form-changed-neatly', function (event) {
      if (me.el[0].id === event.id) {
        return me.resetChanged();
      }
    });
    this.el.on('submit', function () {
      me.resetChanged();
      me.justSaved = true;
    });
  },
  isChanged: function () {
    return !this.justSaved && this.serialized !== this.el.find('[name!=anchor]').serialize();
  },
  resetChanged: function () {
    this.justSaved = false;
    this.serialized = this.el.find('[name!=anchor]').serialize();
  },
  remove: function () {
    var index;
    index = $.inArray(this, observedForms);
    if (index >= 0) {
      observedForms.splice(index, 1);
    }
  },
};

init = function () {
  try {
    return initLestener();
  } catch (e) {
    errorManager(e);
  }
};

findByDom = function (dom) {
  try {
    return findByDomLestener(dom);
  } catch (e) {
    errorManager(e);
  }
};
isChanged = function () {
  try {
    return isChangedLestener();
  } catch (e) {
    errorManager(e);
  }
};
firstChangedForm = function () {
  try {
    return firstChangedFormLestener();
  } catch (e) {
    errorManager(e);
  }
};
window.FormChanges = {
  init: init,
  refresh: init,
  findByDom: findByDom,
  isChanged: isChanged,
  firstChangedForm: firstChangedForm,
};
